import React from 'react';
import { Settings, HelpCircle } from 'lucide-react';

interface SidebarBottomNavProps {
  isCollapsed: boolean;
  isSettingsActive: boolean;
  onOpenSettings: () => void;
  onOpenHelp: () => void;
  onMouseEnter?: (e: React.MouseEvent, itemId: string) => void;
  onMouseLeave?: () => void;
}

export const SidebarBottomNav: React.FC<SidebarBottomNavProps> = ({
  isCollapsed,
  isSettingsActive,
  onOpenSettings,
  onOpenHelp,
  onMouseEnter,
  onMouseLeave,
}) => {
  const items = [
    { id: 'settings', icon: Settings, label: 'Settings', action: onOpenSettings, isActive: isSettingsActive },
    { id: 'help', icon: HelpCircle, label: 'Help', action: onOpenHelp, isActive: false },
  ];

  return (
    <div
      className={`flex ${isCollapsed ? 'flex-col items-center' : 'items-center justify-between'} gap-1 ${
        isCollapsed ? 'p-2' : 'px-4 py-2 pb-3'
      }`}
    >
      {items.map(item => {
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            onClick={item.action}
            onMouseEnter={(e) => onMouseEnter?.(e, item.id)}
            onMouseLeave={onMouseLeave}
            className={`${isCollapsed ? 'w-full flex justify-center' : ''} p-2 rounded-lg transition ${
              item.isActive ? 'bg-white text-neutral-900' : 'text-neutral-500 hover:bg-neutral-200 hover:text-neutral-600'
            }`}
            title={item.label}
            data-tour={item.id === 'settings' ? 'settings-button' : undefined}
          >
            <Icon className="w-4.5 h-4.5" />
          </button>
        );
      })}
    </div>
  );
};
